export default __webpack_public_path__ + "static/media/0314.92835396.jpg";